<div class="app-shell">
  <nav class="sidebar">
    <img src="/landjourney_designsystem_logo.svg" alt="Land Journey" class="sidebar-title" />
    <ul class="nav-list">
      <li>
        <a routerLink="/home" routerLinkActive="active" class="nav-link">Home</a>
      </li>
      <li class="nav-section">
        <button type="button" class="nav-section-header" (click)="toggleVariables()" [attr.aria-expanded]="variablesExpanded">
          <span class="nav-section-label">Variables</span>
          <span class="nav-section-icon" [class.expanded]="variablesExpanded">›</span>
        </button>
        <ul class="nav-sublist" [class.expanded]="variablesExpanded">
          <li><a routerLink="/variables/colors" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/variables/colors')">Colors</a></li>
          <li><a routerLink="/variables/typography" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/variables/typography')">Typography</a></li>
          <li><a routerLink="/variables/spacing" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/variables/spacing')">Spacing</a></li>
          <li><a routerLink="/variables/shadows" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/variables/shadows')">Shadows</a></li>
          <li><a routerLink="/variables/corner-radius" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/variables/corner-radius')">Corner Radius</a></li>
        </ul>
      </li>
      <li class="nav-section">
        <button type="button" class="nav-section-header" (click)="toggleComponents()" [attr.aria-expanded]="componentsExpanded">
          <span class="nav-section-label">Components</span>
          <span class="nav-section-icon" [class.expanded]="componentsExpanded">›</span>
        </button>
        <ul class="nav-sublist" [class.expanded]="componentsExpanded">
          <li><a routerLink="/components/buttons" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/components/buttons')">Buttons</a></li>
          <li><a routerLink="/components/icons" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/components/icons')">Icons</a></li>
          <li><a routerLink="/components/top-bar" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/components/top-bar')">Top Bar</a></li>
          <li><a routerLink="/components/avatars" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/components/avatars')">Avatars</a></li>
          <li><a routerLink="/components/pills" routerLinkActive="active" class="nav-sublink" [attr.data-status]="getPageStatus('/components/pills')">Pills</a></li>
          <li class="nav-subsection">
            <span class="nav-subsection-label">Navigation</span>
            <ul class="nav-subsublist">
              <li>
                <a
                  routerLink="/components/navigation/desktop"
                  routerLinkActive="active"
                  class="nav-sublink nav-sub-sublink"
                  [attr.data-status]="getPageStatus('/components/navigation/desktop')"
                >Desktop Nav</a>
              </li>
              <li>
                <a
                  routerLink="/components/navigation/mobile"
                  routerLinkActive="active"
                  class="nav-sublink nav-sub-sublink"
                  [attr.data-status]="getPageStatus('/components/navigation/mobile')"
                >Mobile Nav</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div class="nav-legend" aria-label="Navigation status legend">
      <div class="nav-legend-item">
        <span class="nav-legend-dot status-success" aria-hidden="true"></span>
        <span>Ready for Dev</span>
      </div>
      <div class="nav-legend-item">
        <span class="nav-legend-dot status-warning" aria-hidden="true"></span>
        <span>In the Work</span>
      </div>
      <div class="nav-legend-item">
        <span class="nav-legend-dot status-error" aria-hidden="true"></span>
        <span>Don't use</span>
      </div>
      <div class="nav-legend-item">
        <span class="nav-legend-dot status-neutral" aria-hidden="true"></span>
        <span>Not Available</span>
      </div>
    </div>
  </nav>
  <main class="content">
    <router-outlet></router-outlet>
  </main>
  <app-toast></app-toast>
</div>
